"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PartnerCard = void 0;
const react_1 = __importDefault(require("react"));
const classFunctions_1 = require("../../../utils/classFunctions");
require("./index.scss");
const className = 'front-partner-card';
class PartnerCard extends react_1.default.PureComponent {
    render() {
        const { name, image, modificators } = this.props;
        const classNames = (0, classFunctions_1.getClassNames)(className, modificators);
        return (react_1.default.createElement("div", { className: classNames },
            react_1.default.createElement("div", { className: `${className}__container` },
                react_1.default.createElement("div", { className: `${className}__image` },
                    react_1.default.createElement("img", { src: image, alt: name })),
                react_1.default.createElement("h3", { className: `${className}__name` }, name))));
    }
}
exports.PartnerCard = PartnerCard;
PartnerCard.defaultProps = {
    name: null,
    image: null,
};
//# sourceMappingURL=index.js.map